export default "__VITE_ASSET__41fa4279__"